import { render, staticRenderFns } from "./IconStarFilled.vue?vue&type=template&id=516e9dde&"
import script from "./IconStarFilled.vue?vue&type=script&lang=js&"
export * from "./IconStarFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports